import { SET_DASHBOARDLIST } from '../actions';

const dashboardlist = (state = [], action) => {
  switch (action.type) {
	case SET_DASHBOARDLIST:
      return [...action.value];  
    default: return state;
  }
}

export default dashboardlist;
